module.exports = __webpack_public_path__ + "assets/19eded733117853d88e7141ac7cec8c7.svg";